export const parseEventMessage = (eventMessage: string) => {
  const [channelName, eventMessages] = JSON.parse(eventMessage);
  const messages = eventMessages.map((eventMessage: any) => {
    return eventMessage[1];
  });
  return {
    channelName,
    messages
  };
};

export const getFinalMessage = (messages: any[]) => {
  const finalMessage = messages.reduce((acc, message) => {
    // Ensure message.data is treated as a string
    return acc + String(message.data || "");
  }, "");

  return finalMessage;
};
